export const siteInfo = {
  name: "八戒影院",
  tagline: "最新影视资源同步更新，热播剧新片上线抢先看不缓冲",
  description: "八戒影院持续同步更新最新影视资源，热播剧与新片上线抢先看不缓冲。汇聚免费电视剧全集与电影大全，高清在线流畅播放。",
  url: "https://bajieyingyuan.com",
  logo: "八戒影院",
  founded: "2019",
  email: "contact@bajieyingyuan.com",
  phone: "400-888-8888",
  address: "北京市朝阳区建国路88号八戒大厦18层",
  social: {
    weibo: "https://weibo.com/bajieyingyuan",
    wechat: "八戒影院",
    douyin: "八戒影院",
  },
};

export const aboutContent = {
  brandIntro: {
    title: "关于八戒影院",
    subtitle: "致力于打造极致的在线观影体验",
    paragraphs: [
      "八戒影院成立于2019年，是国内领先的在线影视平台之一。我们致力于为广大影视爱好者提供最新、最全、最流畅的在线观影体验。自成立以来，八戒影院始终坚持「用户至上、内容为王」的经营理念，不断扩充影视资源库，优化播放技术，为用户带来极致的高清观影享受。",
      "我们的团队由一群热爱影视的专业人士组成，涵盖内容运营、技术研发、产品设计等多个领域。凭借对影视内容的深刻理解和对技术的不懈追求，八戒影院已发展成为拥有海量影视资源和千万级用户群体的优质平台。",
      "在未来的发展中，八戒影院将继续秉承初心，不断引入更多优质影视内容，提升播放技术和服务品质，让每一位用户都能在这里找到心仪的影视作品，享受无忧的观影时光。",
    ],
  },
  reputation: {
    title: "品牌口碑",
    stats: [
      { label: "累计用户", value: "5,800万+" },
      { label: "影视资源", value: "12万+" },
      { label: "日均播放", value: "3,200万+" },
      { label: "用户好评率", value: "98.6%" },
    ],
    testimonials: [
      {
        name: "王小明",
        role: "资深影迷",
        content: "用八戒影院三年了，资源更新真的快，新剧上线当天就能看，画质也高清，太满意了！",
        rating: 5,
      },
      {
        name: "李芳华",
        role: "追剧达人",
        content: "片源太全了，各种冷门老片都能找到，而且完全不卡顿，是我用过最好的影视平台。",
        rating: 5,
      },
      {
        name: "张晓东",
        role: "家庭用户",
        content: "全家人都在用八戒影院，分类清晰，老人小孩都能轻松找到想看的，客服响应也很快。",
        rating: 5,
      },
    ],
  },
  contact: {
    title: "联系我们",
    subtitle: "如有任何问题或建议，欢迎随时与我们取得联系",
    info: [
      { icon: "ri-mail-line", label: "电子邮箱", value: "contact@bajieyingyuan.com" },
      { icon: "ri-phone-line", label: "客服电话", value: "400-888-8888" },
      { icon: "ri-map-pin-line", label: "公司地址", value: "北京市朝阳区建国路88号八戒大厦18层" },
      { icon: "ri-time-line", label: "客服时间", value: "周一至周日 09:00 - 22:00" },
    ],
  },
};